import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { DateTime } from "luxon";
import Moment from "moment";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    alignItems: "center",
    width: "100%"
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1
  },
  iconButton: {
    padding: 6
  }
}));

const InputSearch = ({ resourceRdv, onChange }) => {
  const [options, setOptions] = useState([]);
  const classes = useStyles();

  const handleInputChange = (event, value) => {
    if (value) {
      onChange(value.value);
    }
  };

  useEffect(() => {
    const newValues = resourceRdv?.map((item, key) => {
      return {
        label: `${DateTime.fromISO(item.date_prise_rendez_vous)
          .setLocale("fr")
          .toFormat("EEEE dd MMMM yyyy")} à ${Moment(
          item.heure_debut_prise_rendez_vous,
          "HH:mm:ss"
        ).format("HH:mm")}`,
        value: key
      };
    });
    setOptions(newValues);
  }, [resourceRdv]);

  return (
    <>
      <div
        className={classes.root}
        style={{
          height: "28px",
          width: "100%",
          backgroundColor: "transparent"
        }}
      >
        <Autocomplete
          className={classes.root}
          options={options || []}
          getOptionLabel={option => option.label}
          renderInput={params => (
            <>
              <TextField
                {...params}
                variant="standard"
                className={classes.input}
                placeholder="Rechercher..."
                fullWidth
              />
            </>
          )}
          onChange={handleInputChange}
        />
        <TextField
          variant="standard"
          className={classes.input}
          placeholder="Rechercher..."
        />
      </div>
    </>
  );
};

InputSearch.propTypes = {
  resourceRdv: PropTypes.array,
  dataSource: PropTypes.any,
  onChange: PropTypes.func
};

export default InputSearch;
